function Math() {
  return <h1>Math</h1>;
}

export default Math;